import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import MobileDubWarp from './MobileDubWarp/MobileDubWrap';

import './Mobile.scss';

export default function Mobile() {

  const [isScrolling, setIsScrolling] = useState(false);
  const [isTouching, setIsTouching] = useState(false);
  const history = useHistory();
  //控制图片动画状态
  const [scrollState, setScrollState] = useState({ top: false, one: false, two: false });
  // 处理滚动事件的逻辑
  const handleScroll = (e) => {
    const { deltaX, deltaY } = e;
    const scrollTop = window.scrollY;
    if(Math.abs(deltaX) > Math.abs(deltaY)) {
      // 忽略水平滚动
      return;
    }
    setIsScrolling(scrollTop > 0);
    let timer = null;
    clearTimeout(timer);
    timer = setTimeout(() => {
      const currentScrollTop = window.scrollY;
      //控制动画
      let newState = { top: false, one: false, two: false };
      //控制顶部图片动画
      // if (currentScrollTop >0 && currentScrollTop < 450) {
      //   newState.top = true;
      // }
      if(currentScrollTop > 0 && currentScrollTop < 900) {
        newState.one = true;
      }
      if(currentScrollTop >= 400 && currentScrollTop <= 1500) {
        newState.two = true;
      }
      setScrollState(newState);
      //显示d
      if(scrollTop === currentScrollTop) {
        setIsScrolling(0);
      }
    }, 150);
  };

  useEffect(() => {
    window.addEventListener('touchstart', () => {
      setIsTouching(true);
    }, { passive: true });
    window.addEventListener('touchend', () => {
      setIsTouching(false);
    }, { passive: true });
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll, { passive: true });
      window.removeEventListener('touchstart', () => {
        setIsTouching(true);
      }, { passive: true });
      window.removeEventListener('touchend', () => {
        setIsTouching(false);
      }, { passive: true });
    };
  }, []);

  return (

        <>
            <div className="ai_book-home-mobile">
              <div className="ai-book-ic">
                <img src="https://oss.5rs.me/oss/uploadfe/png/aae0ccdd0d01d04b7602374574265f6d.png" />
              </div>
              <p className="top-title">专为出版行业定制的有声书</p>
              <div className={`ai_book-home-mobile-img ${scrollState.top && 'active'}`}>
                <img className="img-top" src="https://oss.5rs.me/oss/uploadfe/png/e42e9d7d5550ef8adf3b4533be1b4afe.png" />
              </div>
              <div className="content">
                <div className="content-title margin_t_1">文本转<span>真人</span>语音</div>
                <div className="content-tips">一键将文本生成为自然流畅、高表现力的语音</div>
                <div className="content-tips">智能断句、高度拟人</div>
                <div className="content-tips">无限接近真人播音员</div>
                <div className="content-tips">适用于有声书、新闻、短视频制作等场景</div>
              </div>
              <div className={`ai_book-home-mobile-img ${scrollState.one && 'active'}`}>
                <img className="img-one" src="https://oss.5rs.me/oss/uploadfe/png/a7fc01faf5ae7bad8fa48580c1c902ce.png" />
              </div>
              <div className="content">
                <div className="content-title margin_t_2"><span>一站式</span>配音服务</div>
                <div className="content-tips">一站式的语音合成服务，将整个制作流程交给专业团队处理。高效、省时、经济。</div>
                <div className="content-tips">我们有汇集了各种类型、风格和题材的优质创作者团队。根据项目的规模和时间要求灵活调整，满足您的商业需求。</div>
              </div>
              <div className={`ai_book-home-mobile-img ${scrollState.two && 'active'}`}>
                <img className="img-two" src="https://oss.5rs.me/oss/uploadfe/png/c64cc85aa43bec7afe83ec8bba68ec8d.png" />
              </div>

              <div className="content">
                <div className="content-title margin_t_3">丰富的配音，定制你的<span>专属</span>音色</div>
              </div>

              <div className="listening-test">
                <MobileDubWarp />
              </div>

              <div className="qr-Code">
                <h3>联系我们</h3>
                <p>专业、深度、便捷、专为出版行业定制的</p>
                <p>有声书。我们期待您的加入~</p>
                <img src="https://oss.5rs.me/oss/uploadfe/png/4ca6b13d6e1b4046ec188d722150f966.png" />
                <span className="qr-Code-tips">微信扫码 添加专属客服</span>

              </div>
              <div className="ai_book-home-mobile-footer">
                <p>易 · 听书</p>
                <p>Copyright © 2014-2024 中国 武汉理工数字传播工程有限公司</p>
              </div>
            </div>
            <div className={isTouching || isScrolling ? 'fixed-bottom hidden' : 'fixed-bottom visible'}>
              <button
                onClick={() => {
                  history.push('/mobilesubmit');
                }}
              >欢迎咨询了解</button>
            </div>
        </>
  );
}